import { ref } from 'vue';

const open = ref(false);
let resolver: ((activated: boolean) => void) | null = null;

export function openActivationGate(): Promise<boolean> {
  if (open.value && resolver) {
    return new Promise((r) => {
      const prev = resolver;
      resolver = (v) => {
        prev?.(v);
        r(v);
      };
    });
  }
  open.value = true;
  return new Promise((r) => {
    resolver = r;
  });
}

export function resolveActivationGate(activated: boolean): void {
  resolver?.(activated);
  resolver = null;
  open.value = false;
}

export const activationGateOpen = open;
